export const GROUP_PRIVACY = {
  Private: {
    label: 'Nhóm riêng tư',
    icon: '/icons/private-black.svg',
  },
  Public: {
    label: 'Nhóm công khai',
    icon: '/icons/public-gray.svg',
  },
};

export const GROUP_TABS = {
  FEED: {
    label: 'Bảng tin',
    key: 'feed',
  },
  COURSE: {
    label: 'Khóa học',
    key: 'course',
  },
  DOCUMENT: {
    label: 'Tài liệu',
    key: 'document',
  },
  SETTINGS: {
    label: 'Cài đặt',
    key: 'settings',
  },
};


export const SUGGESTED_GROUP_PAGE_SIZE = 8;
export const USER_WALL_GROUP_PAGE_SIZE = 10;